import { Injectable } from '@angular/core';
import { ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { CustomOtpViewComponent } from '@core/custome-modal/custom-otp/custom-otp-view/custom-otp-view.component';
import { config } from '@core/interfaces/api_baseurl';
import { AuthService } from '@core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAccessControlService {

  constructor(
    private _AuthService: AuthService,
    private _ConfirmationModalService: ConfirmationModalService,
  ) { }

  apiAccessVerifyOtp(otp: string) {
    const formdata = new FormData();
    formdata.append('otp', otp);
    return this._AuthService.postdata(formdata, config.Api_Key.verifyOTP);
  }

  sendOtp() {
    return this._AuthService.postdata(null, config.Api_Key.sendOTP);
  }

  OtpModal(data?: any) {
    data = {
      showCloseIcon: true, //show submit button
      title: 'Enter OTP', //show mesg send to mobile
      message: 'We have sent you OTP to your registered phone number/email id for verification', //show mesg send to mobile
      // isSubmitBtn: true, //show submit button
      submitBtnName: 'Submit OTP', //show submit button
      submitBtnClass: 'btn btn-primary',
      otpBox: 4,
      ...data
    }
    const otpMdlInstans = this._ConfirmationModalService.init(CustomOtpViewComponent, {
      data
    });
    return otpMdlInstans;
  }

}
